/* External */
import mapValues from 'lodash/mapValues';

/* Service Creators */
import content from './content';
import entitlement from './entitlement';
import experience from './experience';
import subscriber from './subscriber';
import blim from './blim';

/* Utils */
import createAxiosInstance from './createAxiosInstance';
import { VERSION_MW_1 } from './utils';

/**
 * @callback RenewCredentialsCreator
 * @param {object} backendService
 * @returns {import('./createAxiosInstance').RenewCredentialsCallback}
 */

/**
 * @typedef VersionApiByServiceType
 * @type {object}
 * @property {'v1'} [content]
 * @property {'v1'} [entitlement]
 * @property {'v1'} [experience]
 * @property {'v1'} [subscriber]
 * @property {import('./blim').VersionApiByServiceType} [blim]
 */

/**
 * @typedef CreateBackendServiceParams
 * @type {object}
 * @property {RenewCredentialsCreator} [renewCredentialsCreator]
 * @property {RenewAccessTokenCreator} [renewAccessTokenCreator]
 * @property {VersionApiByServiceType} [versionApiByService]
 */

/**
 * @param {
    CreateBackendServiceParams
    & import('./createAxiosInstance').BackendAxiosInstanceCreatorParams
  } param0
 */
export default function createService({
  renewCredentialsCreator,
  versionApiByService = {},
  ...axiosInstanceParams
}) {
  const backendAxiosInstance = createAxiosInstance(axiosInstanceParams);
  const backendMicroServices = {
    content: content[versionApiByService.content || VERSION_MW_1],
    entitlement: entitlement[versionApiByService.entitlement || VERSION_MW_1],
    experience: experience[versionApiByService.experience || VERSION_MW_1],
    subscriber: subscriber[versionApiByService.subscriber || VERSION_MW_1],
    blim: blim(versionApiByService.blim),
  };

  const backendService = mapValues(
    backendMicroServices,
    (microService) => microService(backendAxiosInstance),
  );

  if (renewCredentialsCreator) {
    backendAxiosInstance.setRenewCredentialsFunction(renewCredentialsCreator(backendService));
  }

  return backendService;
}
